import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import { useModal } from 'context/ModalContext';
import { DimGlyph } from 'components/rebrand/icons';
import { dimensaoByBehavior, hexToRgba } from 'components/rebrand/mappings';

export function ComportamentoHelpModal(props: any) {
  const modalID = 'comportamento-help';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { openModal, modalData, closeModal } = useModal();

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Saiba mais sobre a dimensão"
        portalClassName="relative z-40"
        overlayClassName="rb-modal-overlay"
        contentElement={() => {
          const dimensao = dimensaoByBehavior(modalData);
          return (
            <div className="rb-modal rb-modal--lg">
              <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
                <IoIosClose size={26} />
              </button>

              <div className="rb-modal__header">
                <div className="rb-modal__icon" style={{ background: hexToRgba(dimensao.color, 0.14) }}>
                  <DimGlyph id={dimensao.id} color={dimensao.color} size={40} />
                </div>
                <h1 className="rb-modal__title" style={{ color: dimensao.color }}>
                  {dimensao.label}
                </h1>
              </div>

              <div className="rb-modal__text">{dimensao.descricao}</div>

              <div className="rb-modal__actions">
                <button className="rb-btn-primary" onClick={() => closeModal()}>
                  Fechar
                </button>
              </div>
            </div>
          );
        }}
      />
    </>
  );
}
